// @owlcat/app-shell — client-side Telegram Mini App (TMA) detection + native Stars
// checkout. Lifted from accounts/lib/telegram-webapp so the shared purchase widgets
// can context-gate payment methods without depending on the accounts app.
//
// COMPLIANCE (hard rule): Telegram bans EXTERNAL payment providers (Stripe, cards,
// Apple Pay) for DIGITAL goods sold INSIDE a Telegram Mini App. So the purchase UI
// MUST detect the TMA context and, when inside one, offer ONLY Telegram Stars. The
// single source of truth for "are we in a TMA" is a NON-EMPTY signed
// `window.Telegram.WebApp.initData` (Telegram injects the WebApp SDK + signs initData
// only inside the in-app webview). A plain browser has neither.
//
// This module touches `window` only, so it is import-safe from client components.
// Every function is a no-op / false on the server (no `window`).
function webApp() {
    if (typeof window === "undefined")
        return null;
    const w = window;
    return w.Telegram?.WebApp ?? null;
}
/**
 * True iff running inside a Telegram Mini App webview. Gated on a NON-EMPTY signed
 * initData (not merely the SDK object existing), so an app that lazy-loads the SDK
 * outside Telegram can't false-positive.
 */
export function isTelegramMiniApp() {
    const wa = webApp();
    return !!(wa && typeof wa.initData === "string" && wa.initData.length > 0);
}
/**
 * Pay a Stars invoice link using the NATIVE in-webview flow (Mini App only). The
 * credit still arrives async via the bot's successful_payment webhook — `cb` is a
 * UX signal (close the sheet, refresh the balance), NOT the source of truth. Returns
 * false if not in a TMA / openInvoice unavailable (caller should fall back).
 */
export function openTelegramInvoice(link, cb) {
    const wa = webApp();
    if (!wa || typeof wa.openInvoice !== "function")
        return false;
    wa.openInvoice(link, cb);
    return true;
}
